
    import {Options, Prop, Vue} from 'vue-property-decorator';
    import {PredictCategoryResource} from '@/profile-creation-wizard/common/categories/FamiliesCategories';

    @Options({})
    export default class CategorizationPrediction extends Vue {
        @Prop({type: Array, required: true})
        predictions!: PredictCategoryResource[];
        @Prop({type: Array, required: true, default: []})
        categories!: string[];
        selectedCategories: string[] = [];

        async created(): Promise<void> {
            if (this.categoriesAlreadySelectedManually()) {
                this.$emit('manualSelection');
            }
            this.selectedCategories = [...this.categories];
        }

        categoriesAlreadySelectedManually(): boolean {
            const categoryPredictedIds = this.predictions.map((prediction) => prediction.categoryId);
            if (categoryPredictedIds.length >= this.categories.length) {
                return !this.categories.every((cat) => categoryPredictedIds.includes(cat));
            }
            return true;
        }

        beforeMount(): void {
            if (this.selectedCategories.length === 0) {
                this.$emit('prediction-selection');
            }
        }

        get displayCantFindMyExpertise(): boolean {
            return this.selectedCategories.length === 0;
        }

        isToggled(category: string): boolean {
            return this.selectedCategories.includes(category);
        }

        isExpertise(category: PredictCategoryResource): boolean {
            return this.selectedCategories[0] === category.categoryId;
        }

        togglePrediction(event: Event): void {
            const toggledCategory = (event.target as HTMLInputElement).value;
            const prediction = this.predictions.find((pred) => pred.categoryId === toggledCategory)!;

            if (this.selectedCategories.includes(toggledCategory)) {
                this.selectedCategories = this.selectedCategories.filter((categ) => categ !== toggledCategory);

                const prediction = this.predictions.find((pred) => pred.categoryId === toggledCategory)!;
                this.$emit('inputFamilyCategory', {action: 'unselect', familyId: prediction.familyId, categoryId: toggledCategory});
            } else {
                this.selectedCategories.push(toggledCategory);
                this.$emit('inputFamilyCategory', {action: 'select', familyId: prediction.familyId, categoryId: toggledCategory});
            }
        }

        switchToManualSelection(): void {
            this.$emit('manualSelection');
        }
    }
